import { render, staticRenderFns } from "./home.vue?vue&type=template&id=95ce8c7e&scoped=true&"
import script from "./home.vue?vue&type=script&lang=js&"
export * from "./home.vue?vue&type=script&lang=js&"
import style0 from "./home.vue?vue&type=style&index=0&id=95ce8c7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95ce8c7e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('95ce8c7e')) {
      api.createRecord('95ce8c7e', component.options)
    } else {
      api.reload('95ce8c7e', component.options)
    }
    module.hot.accept("./home.vue?vue&type=template&id=95ce8c7e&scoped=true&", function () {
      api.rerender('95ce8c7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gift/welcome/home.vue"
export default component.exports